import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import './style.scss'

// есть обычная кнопка с текстом внутри (внутри <span></span>), а может быть наоборот - кнопка
// внутри <span></span>
// обертка и содержимое могут быть разными компонентами.
// Это нужно для того, чтоб была еще особая кнопка variant="light", с возможностью сделать кликабельным
// только текст (пропы variant="light", textClick)

const ButtonComponent = ({ type, className, disabled, children, onClick, ariaLabel, theme, variant }) => {
  // const isPrimary = variant === 'primary';
  // const isSecondary = variant === 'secondary';
  // const isLightBordered = variant === 'light-bordered';

  // let bgColor = '#3377bb';
  // let color = '#fff';
  // let borderColor = 'transparent';
  // if (isPrimary && theme) {
  //     bgColor = theme.primaryColor;
  //     color = '#fff';
  // }
  // if (isSecondary && theme) {
  //     bgColor = theme.secondaryColor;
  //     color = '#fff';
  // }
  // if (isLightBordered && theme) {
  //     bgColor = '#fff';
  //     color = theme.primaryColor;
  //     borderColor = theme.secondaryColor;
  // }

  // const style = {
  //     backgroundColor: bgColor,
  //     color: color,
  //     borderColor: borderColor,
  // };

  return (
    <button
      type={type || 'button'}
      aria-label={ariaLabel}
      className={className}
      onClick={onClick}
      disabled={disabled}
      // style={theme ? style : null}
    >
      {children}
    </button>
  )
}

const SpanComponent = ({ className, children, onClick, disabled, theme }) => {
  // const style = {
  //     color: theme && disabled ? theme.primaryDisabledColor : theme && !disabled ? theme.primaryColor : '#3377bb',
  // };
  return (
    <span className={className} onClick={onClick}>
      {children}
    </span>
  )
}

function Button({ type, size, variant, onClick, disabled, children, className, textClick, ariaLabel, theme, style }) {
  const variantClass = `${variant ? ` ${variant}` : ''}`
  const sizeClass = `${
    size === 'huge' ? ' btn-huge' : size === 'big' ? ' btn-big' : size === 'small' ? ' btn-small' : ''
  }`
  const usersClassName = `${className ? ` ${className}` : ''}`
  const textClickClass = `${textClick ? ' text-click' : ''}`
  const mainClass = `button${sizeClass}${variantClass}${usersClassName}${textClickClass}`
  // textClick - это параметр, который позволяет кликать только по тексту в кнопке
  const Wrap = textClick ? SpanComponent : ButtonComponent
  const Inner = textClick ? ButtonComponent : SpanComponent
  const wrapProps = { type, size, variant, disabled, className: mainClass, theme }

  return (
    <Wrap
      {...wrapProps}
      onClick={variant === 'light' && textClick ? null : onClick}
      ariaLabel={ariaLabel}
      style={style}
    >
      <Inner
        onClick={variant === 'light' && textClick ? onClick : null}
        disabled={disabled}
        ariaLabel={ariaLabel}
        style={style}
      >
        {children}
      </Inner>
    </Wrap>
    // <button
    //     type={type ? type : 'button'}
    //     className={mainClass}
    //     onClick={variant === 'light' && textClick ? null : onClick}
    //     disabled={disabled}
    // >
    //     <span onClick={variant === 'light' && textClick ? onClick : null} disabled={disabled}>
    //         {children}
    //     </span>
    // </button>
  )
}

Button.defaultProps = {
  type: 'button',
  variant: 'primary',
  size: 'small',
}

Button.propTypes = {
  type: PropTypes.oneOf(['button', 'reset ', 'submit']),
  variant: PropTypes.oneOf(['primary', 'secondary', 'light-bordered', 'light']),
  size: PropTypes.oneOf(['small', 'big', 'huge']),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  textClick: PropTypes.bool,
  children: PropTypes.node,
  ariaLabel: PropTypes.string.isRequired,
  className: PropTypes.string,
}

const mapStateToProps = (state) => ({
  theme: state.user.theme,
})

export default connect(mapStateToProps)(Button)



// WEBPACK FOOTER //
// ./src/components/button/index.js